import { useMutation } from "react-query";

import { ChangePasswordFormValues} from "@services/apiClient";
import { changePassword } from "@services/users.service";

export const useChangePassword = () => {
  return useMutation((values: ChangePasswordFormValues) => changePassword(values));
};
